import React, { Component } from "react";
import { Div, Text, Image } from "atomize";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";

export default class BuzzArrows extends Component {
  render() {
    const { content } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer>
          <Div m={{ t: {xs: "10rem", md: "14rem"} }}>
            <Div d={{xs: "none", md: "flex"}} pos="relative">
              <Image
                src={content.image1}
                bgSize="contain"
                bgRepeat="no-repeat"
                w="80%"
                h={{md: "300px", lg: "auto"}}
              />
              <Image
                src={content.image2}
                bgSize="contain"
                bgRepeat="no-repeat"
                w="80%"
                h={{md: "290px", lg: "auto"}}
                pos="absolute"
                right="0"
                top="2rem"
              />
              <Text
                p={{ x: {md: "2rem", lg: "4rem"} }}
                textSize="display4"
                textWeight="700"
                style={{lineHeight: "54px"}}
                pos="absolute"
                top="50%"
                textAlign="center"
                tag="h2"
                transform="translateY(-50%)"
              >
                {content.heading}
              </Text>
            </Div>
            <Div
              bgImg={content.mobileImage}
              d={{xs: "block", md: "none"}}
              p={{b: "91.5%"}}
              bgPos="center"
              bgSize="cover"
            ></Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
